"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const design_system_1 = require("@zapier/design-system");
const containerStyle = {
    a: {
        textDecoration: 'none',
        color: design_system_1.Colors.blue500,
    },
    'a:hover': {
        textDecoration: 'underline',
        color: design_system_1.Colors.blue700,
    },
    'a:focus': {
        textDecoration: 'underline',
        color: design_system_1.Colors.blue700,
        outline: 'none',
    },
};
function FieldHelpText({ field }) {
    return (common_utils_1.isolateComponent("div", { css: containerStyle }, field.help_text_html ? (common_utils_1.isolateComponent("div", { dangerouslySetInnerHTML: { __html: field.help_text_html } })) : (common_utils_1.isolateComponent("p", null, field.help_text))));
}
exports.default = FieldHelpText;
